import { useState } from 'react';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { uploadFileToGcloud } from '@api/common';
import { getUploadLogoURL } from '@api/organisations';

import { handleErrorFromMessage } from '@utils/handleRequestError';
import { generateHeaders } from '@utils/headersMapper';

import { ESnackbarTypes } from '@enums/common';

import { HUNDRED_PERCENT_LOADING } from '@constants/common';
import { UPLOAD_LOGO_URL } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseUploadLogoParams {
	setLogoId: (id: string) => void;
	toggleLogoModal: () => void;
	url?: string;
}

export const useUploadLogo = (params: IUseUploadLogoParams) => {
	const [progress, setProgress] = useState<number>(HUNDRED_PERCENT_LOADING);

	const {
		setLogoId,
		toggleLogoModal,
		url,
	} = params;

	const dispatch = useAppDispatch();

	const {
		mutate: createUploadLogoUrl,
		isLoading: isLoadingCreateUploadLogoUrl,
	} = useMutation({
		mutationKey: [UPLOAD_LOGO_URL],
		mutationFn: ({ file }: { file: File }) => {
			getUploadLogoURL({ fileName: file.name, url }).then((data: any) => {
				const headers = generateHeaders(data?.headers);
				const uploadUrl = data?.uploadUrl;

				uploadFileToGcloud({ url: uploadUrl, data: file, headers, onProgressHandler: setProgress }).then(() => {
					if (data?.importId) {
						setLogoId(data.importId);
						toggleLogoModal();
					}
				}).catch((err) => {
					dispatch(setSnackbar({
						message: err?.message || responseMessages.error,
						type: ESnackbarTypes.error,
					}));
				});
			}).catch(err => handleErrorFromMessage(err));
		},
	});

	return {
		createUploadLogoUrl,
		isLoadingCreateUploadLogoUrl,
		progress,
	};
};
